import { useQuery } from '@tanstack/react-query';
import { useMatchRoute } from '@tanstack/react-router';

import { auth0UserQueryOptions } from '#utils/auth0-user-query-options.js';
import { UserControlLogOut } from './user-control-log-out.js';
import { UserControlLoggedIn } from './user-control-logged-in.js';
import { UserControlLoggedOut } from './user-control-logged-out.js';

export function UserControl() {
	const { data: user } = useQuery(auth0UserQueryOptions);
	const matchRoute = useMatchRoute();

	if (user === null) {
		return matchRoute({ to: '/verify-email' }) !== false ? <UserControlLogOut /> : <UserControlLoggedOut />;
	} else {
		return <UserControlLoggedIn user={user} />;
	}
}
